export default "__VITE_ASSET__zjLqnmLU__"